<template>
    <v-container fluid>
      <section class="esign-hero" aria-label="Ringkasan akun">
        <div class="esign-hero__avatar" aria-hidden="true">{{ heroInitials }}</div>
        <div class="esign-hero__body">
          <p class="esign-hero__greeting">Selamat datang,</p>
          <h2 class="esign-hero__name">{{ heroName || '-' }}</h2>
          <div class="esign-hero__chips">
            <span v-if="activeRoleName" class="esign-hero__chip">
              <v-icon small>mdi-shield-account-outline</v-icon>{{ activeRoleName }}
            </span>
            <span v-if="organisasi" class="esign-hero__chip">
              <v-icon small>mdi-domain</v-icon>{{ organisasi }}
            </span>
            <span v-if="heroJabatan" class="esign-hero__chip">
              <v-icon small>mdi-card-account-details-outline</v-icon>{{ heroJabatan }}
            </span>
          </div>
        </div>
      </section>

      <section v-if="quickLinks.length" class="esign-quick" aria-labelledby="esign-quick-title">
        <h3 id="esign-quick-title" class="esign-quick__title">
          <v-icon color="primary">mdi-view-grid-outline</v-icon> Mulai dari sini
        </h3>
        <div class="esign-quick__grid">
          <router-link
            v-for="link in quickLinks"
            :key="link.id"
            :to="link.route"
            class="esign-quick__item"
          >
            <span class="esign-quick__icon"><v-icon color="primary">{{ link.icon || 'mdi-circle-small' }}</v-icon></span>
            <span class="esign-quick__label">{{ link.label }}</span>
            <v-icon small class="esign-quick__arrow">mdi-arrow-top-right</v-icon>
          </router-link>
        </div>
      </section>

      <div class="mb-5">
        <material-card color="primary" title="Profil Pengguna" class="card-wrapper">
          <template v-slot:head-actions>
            <v-btn v-if="canChangePassword" outlined color="primary" to="/ganti-password">
              <v-icon left small>mdi-lock-reset</v-icon>Ganti password
            </v-btn>
            <v-btn depressed color="primary" @click="ubah()">
              <v-icon left small>mdi-pencil-outline</v-icon>Ubah profil
            </v-btn>
          </template>

          <dl class="esign-dl esign-dl--cols">
            <div><dt>Username</dt><dd>{{ formData.username || '-' }}</dd></div>
            <div><dt>Nama lengkap</dt><dd>{{ formData.nama_lengkap || '-' }}</dd></div>
            <div><dt>NIK</dt><dd>{{ formData.nik || '-' }}</dd></div>
            <div><dt>Jabatan</dt><dd>{{ formData.jabatan || '-' }}</dd></div>
            <div><dt>Email</dt><dd>{{ formData.email || '-' }}</dd></div>
            <div><dt>Organisasi (PAU/Fakultas/Sekolah)</dt><dd>{{ organisasi || '-' }}</dd></div>
            <div><dt>Kedaluwarsa password</dt><dd>{{ tanggal_kadaluarsa || '-' }}</dd></div>
            <div><dt>Status BSrE</dt><dd><esign-status-tag v-if="status_bsre" :value="status_bsre" /><span v-else>-</span></dd></div>
          </dl>

          <h3 class="esign-subhead">Peran</h3>
          <div v-if="appliedPeran.length" class="pf-roles">
            <span v-for="peran in appliedPeran" :key="peran.nama" class="pf-role">
              <v-icon small>mdi-shield-account-outline</v-icon>{{ peran.nama }}
            </span>
          </div>
          <p v-else class="pf-file__empty">
            Anda belum memiliki peran apa pun. Hubungi Administrator untuk mendapatkan peran.
          </p>
            <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000" :top="true">
              {{ snackbarText }}
              <v-btn dark text @click="snackbar = false">Tutup</v-btn>
            </v-snackbar>
        </material-card>
      </div>

    </v-container>
  </template>
  
<script>
  import { apiServer } from "../../setup-axios";
  import moment from "moment";
  export default {
    data: () => ({
      peranpenggunas: [],
      organisasi: "",
      penandatangan: false,
      dateFormat: "DD-MM-YYYY",
      tanggal_kadaluarsa:"",
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
      status_bsre: "",
      formData: {
        id:"",
        nama_lengkap:"",
        username:"",
        file_ttd:"",
        file_paraf:"",
        jabatan:"",
        nik:"",
        email:"",
        status: true,
        id_organisasi:"",
        sumber:"",
      },
    }),
    computed: {
      sessionUser() {
        return JSON.parse(localStorage.getItem("user") || "null") || {};
      },
      heroName() {
        // Profile API data first, then the logged-in session user
        const pengguna = this.sessionUser.pengguna || {};
        return this.formData.nama_lengkap || pengguna.nama_lengkap || this.formData.username || this.sessionUser.username || "";
      },
      heroJabatan() {
        return this.formData.jabatan || (this.sessionUser.pengguna || {}).jabatan || "";
      },
      heroInitials() {
        return this.heroName
          .split(/[\s._-]+/)
          .filter(Boolean)
          .slice(0, 2)
          .map(part => part.charAt(0).toUpperCase())
          .join("");
      },
      activeRoleName() {
        const user = JSON.parse(localStorage.getItem("user") || "null");
        if (!user || !user.list_peran) return "";
        const peran = user.list_peran.find(p => p.kode_peran === localStorage.getItem("currentPeran"));
        return peran ? peran.nama : "";
      },
      quickLinks() {
        // Same menu list and Keycloak rule as the sidebar (core/Drawer.vue)
        const user = JSON.parse(localStorage.getItem("user") || "null");
        if (!user || !user.list_menu) return [];
        const menus = user.list_menu[localStorage.getItem("currentPeran")] || [];
        const isKeycloak = localStorage.getItem("token-type") === "Keycloak";
        return menus
          .filter(m => m.route && m.route !== "none" && m.route !== this.$route.path)
          .filter(m => !(isKeycloak && m.nama === "GantiPassword"))
          .map(m => {
            const label = m.nama.replace(/Daftar/g, "").replace(/([A-Z])/g, " $1").trim();
            return { id: m.id, route: m.route, icon: m.icon, label: label.charAt(0).toUpperCase() + label.slice(1) };
          });
      },
      // SSO (Keycloak) users change their password in SSO, not here
      canChangePassword() {
        return localStorage.getItem("token-type") !== "Keycloak";
      },
     appliedPeran(){
          return this.peranpenggunas.filter((peran, index, self) =>
          index === self.findIndex((t) => (
            t.nama === peran.nama
          ))
        );
      }
    },
    created() {
      console.log("====================================");
      console.log("created profil");
      this.getData();
      console.log("finish created profil")
      console.log("====================================");
    },
    methods: {
      getData() {
        this.formData.id = JSON.parse(localStorage.getItem("user")).id
        console.log("get data " + this.formData.id)
        apiServer
          .get("/pengguna/profil/id/" + this.formData.id)
          .then(response => {
            console.log("get profil success")
            console.log(response.data.data)
            this.formData = response.data.data.pengguna
            this.formData.id_organisasi = response.data.data.pengguna.id_organisasi
            this.organisasi = response.data.data.pengguna.Organisasi.Nama
            this.peranpenggunas = response.data.data.listperan
            this.status_bsre = JSON.parse(response.data.data.status_bsre).message;
            if(localStorage.getItem("token-type") === "Keycloak") {
              this.tanggal_kadaluarsa = "Silakan cek di SSO Anda"
            } else {
              this.tanggal_kadaluarsa = moment.utc(response.data.data.kadaluarsa_password).locale("id").format(this.dateFormat) 
            }
            if(this.peranpenggunas.find(peran => peran.nama === 'Penandatangan') !== undefined) {
              this.penandatangan = true
            }
            if(localStorage.getItem("updateSuccess") != null) {
              this.showSnackbar("orange", localStorage.getItem("updateSuccess"));
              localStorage.removeItem("updateSuccess")
            }
            console.log(this.formData)
            console.log(this.peranpenggunas)
            console.log(this.tanggal_kadaluarsa)
          })
          .catch(error => {
            console.log("There was an error profil:");
            console.log(error) // Logs out the error
          });
      },
      showSnackbar(color, message) {
        console.log("snack " + color + " - " + message);
        this.snackbar = true;
        this.snackbarText = message;
        this.snackbarColor = color;
      },
      showMessage () {
        this.showSnackbar(
            this.$store.state.snackbar.snackbarColor,
            this.$store.state.snackbar.snackbarText
        )
        this.$store.dispatch('setSnackbar', {
          snackbarColor: null,
          snackbarText: null,
        })
      },
      ubah() {
        this.$router.push("/profil/ubah");
      },
    }
  }
</script>
  
<style scoped>
.esign-hero {
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 24px;
  padding: 28px 32px;
  overflow: hidden;
  border-radius: var(--esign-radius-lg);
  background: var(--color-brand);
  color: #fff;
  box-shadow: var(--esign-shadow-md);
}

.esign-hero__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 72px;
  height: 72px;
  border-radius: 20px;
  background: var(--esign-accent);
  color: var(--esign-navy);
  font-size: 26px;
  font-weight: 800;
}

.esign-hero__body {
  position: relative;
  z-index: 1;
  min-width: 0;
}

.esign-hero__greeting {
  font-size: 14px !important;
  color: rgba(255, 255, 255, 0.85);
}

.esign-hero__name {
  margin: 2px 0 12px;
  font-size: 26px !important;
  font-weight: 800 !important;
  line-height: 1.25 !important;
  color: #fff;
  overflow-wrap: anywhere;
}

.esign-hero__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.esign-hero__chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.1);
  font-size: 13px;
  font-weight: 600;
}

.esign-hero__chip .v-icon {
  color: #fff;
}

.esign-quick {
  margin-bottom: 24px;
}

.esign-quick__title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 18px !important;
  font-weight: 700 !important;
  color: var(--esign-text);
}

.esign-quick__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
}

.esign-quick__item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 72px;
  padding: 14px 36px 14px 14px;
  border: 1px solid var(--esign-border);
  border-radius: var(--esign-radius-md);
  background: var(--esign-surface);
  box-shadow: var(--esign-shadow-sm);
  color: var(--esign-text) !important;
  text-decoration: none;
  transition: border-color var(--esign-fast) var(--esign-ease),
    box-shadow var(--esign-fast) var(--esign-ease),
    transform var(--esign-fast) var(--esign-ease);
}

.esign-quick__item:hover {
  border-color: var(--esign-primary);
}

.esign-quick__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: var(--esign-primary-subtle);
}

.esign-quick__label {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.35;
}

.esign-quick__arrow {
  position: absolute;
  top: 12px;
  right: 12px;
  color: var(--esign-text-subtle) !important;
}

.esign-quick__item:hover .esign-quick__arrow {
  color: var(--esign-primary) !important;
}

@media (max-width: 600px) {
  .esign-hero {
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
  }

  .esign-hero__avatar {
    width: 56px;
    height: 56px;
    font-size: 20px;
    border-radius: 16px;
  }

  .esign-hero__name {
    font-size: 20px !important;
  }

  /* Two compact tiles per row instead of one tall card per row */
  .esign-quick__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .esign-quick__item {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    min-height: 0;
    padding: 12px;
  }

  .esign-quick__icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
  }

  .esign-quick__label {
    font-size: 13px;
    overflow-wrap: anywhere;
  }

  .esign-quick__arrow {
    top: 10px;
    right: 10px;
  }
}
/* Empty-state note (no roles yet) */
.pf-file__empty {
  margin: 0 !important;
  font-size: 13px !important;
  line-height: 19px !important;
  color: var(--esign-text-subtle);
}

.pf-roles {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.pf-role {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid var(--esign-border);
  background: var(--esign-surface-muted);
  font-size: 13px;
  font-weight: 600;
  color: var(--esign-text);
}

.pf-role .v-icon {
  color: var(--esign-primary);
}

</style>
